import { render, staticRenderFns } from "./quote-report-card.vue?vue&type=template&id=2f723e5a"
import script from "./quote-report-card.vue?vue&type=script&lang=js"
export * from "./quote-report-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports